export default __webpack_public_path__ + "static/media/logo-bachiller-digital.b84d151d.png";